import images from '../../../assets/images';
import './CommonChatPersonCard.scss';
import { FC } from 'react';
import { ChatListType, DefaultUserType, SearchUserType } from '../CommonChats';

interface PropsStyle{
    groupChatData?: ChatListType,
    chatData?: DefaultUserType,
    searchChatData?: SearchUserType,
    onClick: () => void,
    selectedChat?: DefaultUserType | undefined,
    selectedGroupChat?: ChatListType | undefined,
    selectedSearchChat?: SearchUserType | undefined,
    type : string
}
const CommonChatPersonCard:FC<PropsStyle> = ({groupChatData, searchChatData, chatData, selectedSearchChat,selectedGroupChat, selectedChat, onClick, type}) => {
    const {GroupChatIcon, UserActiveIcon, User} = images;
    const baseUrl = process.env.REACT_APP_FRONTEND_URL;

  return (
    type === "search" ?
    (
        <div 
        className={`CommonChatPersonCardContainer oneToOneChatCard ${searchChatData?.uId === selectedSearchChat?.uId ? 'oneToOneChatCardActive' : ''}`}
        onClick={onClick}
    >
        <div  className='GroupChatIconContainer'>
            <img 
                src={
                    (searchChatData?.uRole === 'TEACHER' && searchChatData?.teachersByUId?.nodes?.[0]?.tAvatarUrl) 
                    ? (baseUrl+searchChatData?.teachersByUId?.nodes?.[0]?.tAvatarUrl)
                    :(searchChatData?.uRole === 'STUDENT' && searchChatData?.studentsByUId?.nodes?.[0]?.sAvatarUrl) 
                        ? (baseUrl+searchChatData?.studentsByUId?.nodes?.[0]?.sAvatarUrl)
                        : User
                    } 
                alt='group'  
                className='GroupChatIconStyle'
            />
        </div>
        <label 
            className={'oneToOneLableStyle'}
        >
            {`${searchChatData?.uFullName}`}
        </label>
    </div>
    ):type === "defaultUser" ? (
        <div 
        className={`CommonChatPersonCardContainer oneToOneChatCard ${chatData?.chatId === selectedChat?.chatId ? 'oneToOneChatCardActive' : ''}`}
        onClick={onClick}
    >
        <div  className='GroupChatIconContainer'>
            <img
                src={((chatData?.from?.uRole === "TEACHER") && chatData?.to?.teachersByUId?.nodes?.[0]?.tAvatarUrl) 
                        ? (baseUrl + chatData?.to?.teachersByUId?.nodes?.[0]?.tAvatarUrl)
                        :((chatData?.from?.uRole === "STUDENT") && chatData?.to?.studentsByUId?.nodes?.[0]?.sAvatarUrl)
                          ? (baseUrl + chatData?.to?.studentsByUId?.nodes?.[0]?.sAvatarUrl) : User}
                alt='group' className='GroupChatIconStyle' />
        </div>
        <label 
            className={'oneToOneLableStyle'}
        >
           {chatData?.to?.uFullName}
        </label>
        {
            chatData?.to?.uChatActive 
            && <img src={ UserActiveIcon } alt={`active`} className='userActiveStyle'/>
        }
        {(chatData?.unReadMessagesCount !== undefined && chatData?.unReadMessagesCount > 0) && 
         (<div  className={chatData?.unReadMessagesCount > 0 ?'chatUnreadCountStyle':'chatUnreadCountStyleDisable'}>
            {chatData?.unReadMessagesCount}
          </div>
        )}
    </div>
    ):(
    <div 
        className={`CommonChatPersonCardContainer groupChatCard ${groupChatData?.chatId === selectedGroupChat?.chatId ? 'groupChatCardActive' : ''}`}
        onClick={onClick}
    >
        <div  className='GroupChatIconContainer'>
            <img src={GroupChatIcon} alt='group'  className='GroupChatIconStyle'/>
        </div>
        <label 
            className={'groupLableStyle'}
        >
            {`${groupChatData?.chatroomName}`}
        </label>
    </div>
    )
  )
}

export default CommonChatPersonCard;
